import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Music = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="music icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.007 40.8377C29.3625 40.8377 27.2096 38.6868 27.2096 36.0403C27.2096 33.3957 29.3625 31.2428 32.007 31.2428C34.6535 31.2428 36.8065 33.3957 36.8065 36.0403C36.8065 38.6868 34.6535 40.8377 32.007 40.8377ZM20.8071 15.706V7.55282L36.8065 3.70162V11.8548L20.8071 15.706ZM12.8035 45.0854C9.99579 45.0854 7.71461 42.8023 7.71461 39.9945C7.71461 37.1887 9.99579 34.9037 12.8035 34.9037C15.6094 34.9037 17.8925 37.1887 17.8925 39.9945C17.8925 42.8023 15.6094 45.0854 12.8035 45.0854ZM17.8925 5.25604V33.868C16.5051 32.7118 14.7466 31.989 12.8035 31.989C8.38886 31.989 4.79999 35.5818 4.79999 39.9945C4.79999 44.4092 8.38886 48 12.8035 48C17.2163 48 20.8071 44.4092 20.8071 39.9945V18.7041L36.8065 14.8529V30.0498C35.4852 28.9889 33.8277 28.3282 32.007 28.3282C27.7556 28.3282 24.2949 31.7889 24.2949 36.0403C24.2949 40.2937 27.7556 43.7524 32.007 43.7524C36.2585 43.7524 39.7211 40.2937 39.7211 36.0403V0L17.8925 5.25604Z"
    />
  </svg>
)
